import { i18n } from 'invision-core';
import CustomerCareLocaleKeys from '../../locales/keys';
export var CUSTOMERCARE_PAGE_APP_ID = 'care';
export default {
  CUSTOMERCARE_PAGE_APP_ID: CUSTOMERCARE_PAGE_APP_ID
};
export var SEARCH_NAV_ITEM_ID = 'search';
export var RECENT_CUSTOMERS_NAV_ITEM_ID = 'recentCustomers';
export var SALES_PIPELINE_NAV_ITEM_ID = 'salesPipeline';
export var LoadNavigatorItems = function LoadNavigatorItems() {
  var isSalesPipelineEnabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var items = [{
    id: SEARCH_NAV_ITEM_ID,
    isActive: false,
    glyph: 'search',
    caption: i18n.translate(CustomerCareLocaleKeys.NAVIGATOR_CAPTION.SEARCH)
  }, {
    id: RECENT_CUSTOMERS_NAV_ITEM_ID,
    isActive: false,
    glyph: 'past',
    caption: i18n.translate(CustomerCareLocaleKeys.RECENT_CUSTOMERS)
  }];
  if (isSalesPipelineEnabled) {
    items.push({
      id: SALES_PIPELINE_NAV_ITEM_ID,
      isActive: false,
      glyph: 'storefront',
      caption: i18n.translate(CustomerCareLocaleKeys.SALES_PIPELINE)
    });
  }
  return items;
};
export var NavigatorFlyoutCaption = function NavigatorFlyoutCaption() {
  return i18n.translate(CustomerCareLocaleKeys.NAVIGATOR_CAPTION.FLYOUT);
};
export var NavigatorItemIndex = {
  SEARCH: 0,
  RECENT: 1,
  SALES_PIPELINE: 2
};
export var customerCareRoute = 'index.customercare';
export var UserTypes = {
  HumanInternal: 1,
  HumanClient: 2,
  HumanPartner: 3,
  ServiceInternal: 4,
  ServiceClient: 5,
  ServicePartner: 6
};
export var ServiceUserTypes = [UserTypes.ServiceInternal, UserTypes.ServiceClient, UserTypes.ServicePartner];